export const th = {
    default: {
        search: 'ค้นหา',
        confirm: 'ยืนยัน',
    },
    date: {
        days: 'วัน',
        months: 'เดือน',
        years: 'ปี',
        minutes: 'นาที',
        minutes_short: 'น.',
        hours: 'ชั่วโมง',
        hours_short: 'ช.ม.',
        second: 'วินาที',
        date_flase: 'กรุณาระบุวันเกิด',
        month_full: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
        month_short: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
        month_full_arr: [{ strvalue: "01", strtext: 'มกราคม' },
        { strvalue: '02', strtext: 'กุมภาพันธ์' },
        { strvalue: '03', strtext: 'มีนาคม' },
        { strvalue: '04', strtext: 'เมษายน' },
        { strvalue: '05', strtext: 'พฤษภาคม' },
        { strvalue: '06', strtext: 'มิถุนายน' },
        { strvalue: '07', strtext: 'กรกฎาคม' },
        { strvalue: '08', strtext: 'สิงหาคม' },
        { strvalue: '09', strtext: 'กันยายน' },
        { strvalue: '10', strtext: 'ตุลาคม' },
        { strvalue: '11', strtext: 'พฤศจิกายน' },
        { strvalue: '12', strtext: 'ธันวาคม' }]
    },
    confirm_redeem: {
        confirm: "รับสิทธิ์",
        cancel: "ยกเลิก",

        headline: 'ยืนยันการแลกสิทธิ์',
        free: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        free_no_timer: 'คุณยืนยันรับสิทธิพิเศษนี้ใช่หรือไม่',
        free_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        draw: 'ยืนยันเพื่อเข้าร่วมสนุก <br/> ประกาศผู้ชนะหลังวันที่ {0}',
        draw_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        deal: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        deal_no_timer: 'คุณยืนยันรับสิทธิพิเศษนี้ใช่หรือไม่',
        deal_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        buy: 'ยืนยันการซื้อ',
        buy_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        interface: 'ยืนยันเพื่อเข้าสู่เว็บไซต์ที่ร่วมรายการ',
    },
    redeem_button: {
        default: 'กดรับสิทธิ์',
        none: '',
        soldOut: 'ขออภัย มีผู้ใช้สิทธิ์เต็มจำนวนแล้ว',
        soldOutBuy: 'ขออภัย มีผู้ใช้สิทธิ์เต็มจำนวนแล้ว',
        maxPerPerson: 'ขออภัย คุณได้ใช้สิทธิพิเศษนี้แล้ว คุณสามารถดูสิทธิ์ที่รับได้ที่ประวัติการรับสิทธิ์',
        survey_maxPerPerson: 'ขออภัย คุณได้ทำแบบสอบถามนี้แล้ว สามารถดูสิทธิ์ได้ที่ประวัติการรับสิทธิ์',
        redeemCoolDown: 'ขออภัย คุณได้ใช้สิทธิพิเศษนี้แล้ว คุณสามารถดูสิทธิ์ที่รับได้ที่ประวัติการรับสิทธิ์ และรับสิทธิ์ครั้งต่อไปภายหลัง',
        nextDate: 'ขออภัย คุณได้ใช้สิทธิพิเศษนี้แล้ว<br/>คุณสามารถดูสิทธิ์ที่รับได้ที่ประวัติการรับสิทธิ์<br/>รับสิทธิ์ครั้งต่อไปได้ตั้งแต่ : ',
        survey_nextDate: 'ขออภัย คุณได้ทำแบบสอบถามนี้แล้ว<br/>สามารถตรวจสอบได้ที่ประวัติการรับสิทธิ์<br/>ทำแบบสอบถามครั้งต่อไปได้ตั้งแต่ : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'ขออภัย คุณไม่เข้าเงื่อนไขการรับสิทธิ์ สามารถดูกิจกรรมและบริการอื่นๆได้ที่หน้าหลัก',
        campaignExpired: 'สิ้นสุดระยะเวลาแคมเปญแล้ว',
        campaignExpiredBuy: 'สิ้นสุดระยะเวลาแคมเปญแล้ว',
        campaignNotAvailable: 'สิทธิพิเศษนี้ไม่สามารถรับได้ในตอนนี้',
        campaignNotAvailableBuy: 'สินค้านี้ไม่สามารถรับได้ในตอนนี้',
        notEnoughPoint: 'คะแนนของคุณไม่เพียงพอที่จะแลกรับสิทธิ์',
        notSupport: 'ไม่รองรับแคมเปญประเภทนี้'
    },
    purchase: {
        Headline: 'ประวัติการรับสิทธิ์',
        show_code: 'กดเพื่อใช้รหัส',
        code_expired: 'รหัสหมดอายุ',

        status: 'สถานะ',
        prepare_product: 'จัดเตรียมสินค้า',
        delivery: 'กำลังจัดส่งสินค้า',
        shipped: 'จัดส่งสำเร็จ',
        parcel_no: 'พัสดุเลขที่',
        redeem_on: 'รับสิทธิ์วันที่',

        wait_survey: 'รอการตรวจสอบ',
        approve_survey: 'อนุมัติ',
        reject_survey: 'ไม่อนุมัติ',

        not_draw1: 'รางวัลนี้ยังไม่ได้ประกาศรายชื่อผู้โชคดี',
        not_draw2: 'กรุณากลับมาตรวจสอบใหม่ภายหลัง',
        draw_winner1: 'ขอแสดงความยินดีด้วยค่ะ',
        draw_winner2: 'คุณเป็นผู้โชคดีได้รับของรางวัล',
        draw_not_win1: 'ขออภัย คุณไม่ใช่ผู้โชคดีได้รับของรางวัลนี้',
        draw_not_win2: 'กรุณาร่วมสนุกกันใหม่ในครั้งหน้า',
    },
    serial: {
        close_btn: 'ปิด',
        Headline: 'ยืนยันการแลกสิทธิ์',
        show_code_at_shop: 'กรุณาแสดงรหัสนี้ ให้แก่ร้านค้า',

        delivery: 'สินค้าจะถูกจัดส่งตามเงื่อนไขของแคมเปญ',

        draw: 'ขอบคุณที่ร่วมสนุกกับเรา<br/>กรุณาติดตามประกาศผล หลังจากวันที่ {0}',
        draw_after: 'หลังจากวันที่',

        qr_code: 'คิวอาร์โค้ด',
        barcode: 'บาร์โค้ด',
        code: 'โค้ด',

        expire_in: 'หมดอายุใน ',
        code_expired: 'รหัสหมดอายุ',

        redeem_on: 'รับสิทธิ์เมื่อ {0}',
        serial_msg: 'กรุณาแสดงสิทธิ์ที่หน้าร้านค้าภายในเวลาที่กำหนด',
        next_use: 'ใช้ภายหลัง'
    },
    shipping: {
        headline: 'ที่อยู่จัดส่ง',

        name: {
            name: 'ชื่อที่อยู่',
            placeholder: 'ชื่อ',
            required: 'กรุณากรอกชื่อ',
            too_short: '',
            invalid: '',
        },

        firstname: {
            name: 'ชื่อ',
            placeholder: 'ชื่อ',
            required: 'กรุณากรอกชื่อ',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'นามสกุล',
            placeholder: 'นามสกุล',
            required: 'กรุณากรอกนามสกุล',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'ที่อยู่',
            placeholder: 'กรุณากรอกที่อยู่',
            required: 'กรุณากรอกที่อยู่',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'เบอร์โทรศัพท์',
            placeholder: 'เบอร์โทรศัพท์',
            required: 'กรุณากรอกเบอร์โทรศัพท์',
            too_short: 'เบอร์โทรศัพท์ต้องมี {0} หลัก',
            invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
        },
        nationalid: {
            name: 'เลขประจำตัวประชาชน',
            placeholder: 'เลขประจำตัวประชาชน',
            required: 'กรุณากรอกเลขประจำตัวประชาชน',
            too_short: 'เลขประจำตัวประชาชนต้องมี {0} หลัก',
            invalid: 'เลขประจำตัวประชาชนไม่ถูกต้อง',
        },
        email: {
            name: 'อีเมล',
            placeholder: 'อีเมล',
            required: 'กรุณากรอกอีเมล',
            too_short: '',
            invalid: 'อีเมลไม่ถูกต้อง',
        },
        zipcode: {
            name: 'รหัสไปรษณีย์',
            placeholder: 'รหัสไปรษณีย์',
            required: 'กรุณากรอกรหัสไปรษณีย์',
            too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
            invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
        },
        subdistrict: {
            name: 'เขต/ตำบล',
            placeholder: 'กรุณาเลือกเขต/ตำบล',
            required: 'กรุณาเลือกเขต/ตำบล',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'แขวง/อำเภอ',
            placeholder: 'กรุณาเลือกแขวง/อำเภอ',
            required: 'กรุณาเลือกแขวง/อำเภอ',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'จังหวัด',
            placeholder: 'กรุณาเลือกจังหวัด',
            required: 'กรุณาเลือกจังหวัด',
            too_short: '',
            invalid: '',
        },

        save_address: 'ตั้งเป็นค่าเริ่มต้น',
        save_address_buy: 'บันทึกที่อยู่เพื่อใช้ในการสั่งซื้อครั้งต่อไป',

        confirm_btn: 'ยืนยัน',
        cancel_btn: 'ยกเลิก',

        alert_headline: 'ที่อยู่จัดส่ง',
        alert_ok_btn: 'ตกลง',
    },
    main: {
        home_page: "หน้าแรก",
        login: "เข้าสู่ระบบ",
        campaign: "แคมเปญ",
        map: "แผนที่",
        history: 'ประวัติรับสิทธิ์',
        profile: "โปรไฟล์",
        logout: "ออกจากระบบ",
        lang: "ภาษา",
        msgLogout: "ต้องการออกจากระบบ",
        cancel: "ยกเลิก",
    },
    campaign: {
        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',
    },
    home: {
        empty_campaign: "ขออภัย ไม่พบสิทธิพิเศษที่คุณค้นหา",
        history: "ดูประวัติการรับสิทธิ์",
        your_privileges: "สิทธิพิเศษสำหรับคุณ",
        search: "ค้นหา",
        cancel: "ยกเลิก",
    },
    detail: {
        detail: 'รายละเอียด',
        condition: 'เงื่อนไข',

        balance: 'สิทธิ์คงเหลือ',
        balance_2: 'สิทธิ์',
        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',
        available_date: 'แลกได้วันที่',
        expire_date: 'หมดอายุภายในวันที่',

        color: {
            name: 'สี',
            placeholder: 'กรุณาเลือกสี',
            required: 'กรุณาเลือกสี',
        },
        size: {
            name: 'ขนาด',
            placeholder: 'กรุณาเลือกขนาด',
            required: 'กรุณาเลือกขนาด',
        },
        max_redeem: 'ขออภัย มีผู้ใช้สิทธิ์เต็มจำนวนแล้ว'
    },
    history: {
        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',

        parcel_number: 'เลขพัสดุ : ',
        empty: 'ไม่พบข้อมูล'
    },
    consent: {
        headline: 'ข้อตกลงและเงื่อนไขการใช้งาน',
        agree: 'ข้าพเจ้ายอมรับข้อกำหนดและเงื่อนไขนโยบายความเป็นส่วนตัว',
        btn_next: 'เริ่มต้นใช้งาน'
    },
};
